import { render, staticRenderFns } from "./breadSlice.vue?vue&type=template&id=fa65e064&"
import script from "./breadSlice.vue?vue&type=script&lang=js&"
export * from "./breadSlice.vue?vue&type=script&lang=js&"
import style0 from "./breadSlice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports